import { useTranslation } from "../localization/useTranslation.ts";
import { get } from "../common/api/apiShared.ts";
import { ContractModel } from "./contract/Contract.types.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { ContractStandardField } from "../entityTemplates/EntityTemplate.types.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export const useRemoveContractDate = (onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>) => {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();

    const checkMutation = useDotLegalMutation(canRemoveContractDateApi);

    const onRemoveContractDate = (contractId: string, fieldType: ContractStandardField) => {
        checkMutation.mutateAsync(
            { contractId: contractId, fieldType: fieldType },
            {
                onSuccess: (canBeRemoved: boolean) => {
                    if (canBeRemoved) {
                        if (fieldType === ContractStandardField.StartDate) {
                            onChange((c) => {
                                c.startDate = undefined;
                            });
                        } else if (fieldType === ContractStandardField.EndDate) {
                            onChange((c) => {
                                c.endDate = undefined;
                                c.autoRenewalDuration = undefined;
                                c.autoRenewalDurationType = undefined;
                            });
                        }
                    } else {
                        snackbar.show(
                            fieldType === ContractStandardField.StartDate
                                ? translateString("obligationDependsOnStartDate")
                                : translateString("obligationDependsOnEndDate"),
                            "warning"
                        );
                    }
                },
            }
        );
    };

    return { onRemoveContractDate, isCheckingDate: checkMutation.isLoading };

    async function canRemoveContractDateApi(data: { contractId: string; fieldType: ContractStandardField }) {
        return await get<boolean>(`/contracts/${data.contractId}/${data.fieldType === ContractStandardField.StartDate ? "startDate" : "endDate"}`);
    }
};
